import React, {useState, useEffect, useRef} from 'react';
import './timer-heartbeats.css';

const TimerHeartbeats = ({duration}) => {
  const [initialTime, setInitialTime] = useState(duration);
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isRunning, setIsRunning] = useState(false);
  const [progress, setProgress] = useState(0);
  const canvasRef = useRef(null);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(Date.now());
  const timeRemainingRef = useRef(initialTime);

  useEffect(() => {
    if (!isRunning) return;

    const updateProgress = () => {
      const elapsedTime = (Date.now() - startTimeRef.current) / 1000;
      const timeRemaining = Math.max(0, timeRemainingRef.current - elapsedTime);
      setTimeLeft(timeRemaining);

      if (duration !== undefined) {
        const currentProgress = ((initialTime - timeRemaining) / initialTime) * 100;
        setProgress(currentProgress);
      }

      if (timeRemaining === 0) {
        setProgress(0);
        clearInterval(intervalRef.current);
        setIsRunning(false);
      }
    };

    intervalRef.current = setInterval(updateProgress, 10);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isRunning]);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const width = 70;  // Фізичний розмір канвасу на екрані
    const height = 70; // Фізичний розмір канвасу на екрані

    const scale = window.devicePixelRatio || 1; // Множник для масштабування

    // Встановлюємо канвас на фізичний розмір (70px) через CSS
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    // Встановлюємо внутрішні розміри канвасу з урахуванням devicePixelRatio
    canvas.width = width * scale;
    canvas.height = height * scale;

    // Масштабуємо контекст канвасу
    ctx.scale(scale, scale);

    const radius = width / 2;  // радіус в фізичних пікселях
    const startAngle = -Math.PI / 2; // Початковий кут
    const progressColor = '#E5DDFF';
    const endAngle = startAngle + (2 * Math.PI * (progress / 100));

    // Очищаємо попереднє малювання
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Малюємо фон
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 4, 0, 2 * Math.PI);
    ctx.strokeStyle = '#6F525C';
    ctx.lineWidth = 1.5;
    ctx.stroke();

    // Малюємо прогрес
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 4, startAngle, endAngle);
    ctx.strokeStyle = progressColor;
    ctx.lineWidth = 1.5;
    ctx.stroke();

    // Малюємо статичне коло
    const staticCircleRadius = 3;
    const staticCircleX = radius;
    const staticCircleY = radius - radius + 4;

    ctx.beginPath();
    ctx.arc(staticCircleX, staticCircleY, staticCircleRadius, 0, 2 * Math.PI);
    ctx.fillStyle = '#6F525C';
    ctx.fill();
  }, [progress]);

  const handlePause = () => {
    if (!isRunning) return;
    setIsRunning(false);
    setTimeLeft(duration);
    setProgress(0);
    setInitialTime(duration);
    timeRemainingRef.current = duration;
    clearInterval(intervalRef.current);
  };

  const handleResume = () => {
    if (isRunning) return;
    startTimeRef.current = Date.now();
    setIsRunning(true);
  };

  return (
    <div className="heartbeats-timer-container">
      <canvas className="heartbeats-timer-circle" ref={canvasRef}></canvas>
      <div
        className={`time-remaining-duration ${isRunning ? 'time-visible-pulse' : ''}`}
        onClick={handlePause}
      >
        {Math.ceil(timeLeft)}
      </div>
      <div
        className={`resume-time-pulse ${!isRunning ? 'time-visible-pulse' : ''}`}
        onClick={handleResume}
      >
        <img
          loading="lazy"
          src={require('./timer-heartbeats-img/play.svg').default}
          width={20}
          alt="image for exercise continue"
        />
      </div>
    </div>
  );
};

export default TimerHeartbeats;



